import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { toPercent } from '../../utils/index.js';
export const percent = (share) => `${toPercent(share, { precision: 0 })}%`;
export const Description = styled.p `
  color: ${THEME.COLOR_GREY};
  font-size: 0.85em;
  margin: 0 0 ${THEME.GRID_SPACING}px 0;
`;
//# sourceMappingURL=shared.js.map